export const FREE_DELIVERY_MINIMUM = 1000;

export const UAE_DELIVERY_CHARGES = Object.freeze({
  dubai: 20,
  abu_dhabi: 30,
  sharjah: 30,
  ajman: 30,
  umm_al_quwain: 30,
  ras_al_khaimah: 30,
  fujairah: 30,
});

export const INVALID_UAE_EMIRATE_MESSAGE =
  "Please select a valid UAE emirate in your delivery address.";

export const FREE_DELIVERY_QUALIFIED_MESSAGE =
  "You have qualified for free delivery.";

export const CART_DELIVERY_PENDING_MESSAGE =
  "Free delivery is available on orders of AED 1,000 or more. Delivery charges will be calculated after you add your delivery address at checkout.";

const EMIRATE_ALIASES = Object.freeze({
  dubai: "dubai",
  abu_dhabi: "abu_dhabi",
  abudhabi: "abu_dhabi",
  sharjah: "sharjah",
  ajman: "ajman",
  umm_al_quwain: "umm_al_quwain",
  umm_alquwain: "umm_al_quwain",
  ummalquwain: "umm_al_quwain",
  ras_al_khaimah: "ras_al_khaimah",
  rasalkhaimah: "ras_al_khaimah",
  fujairah: "fujairah",
});

const normalizeEmirateToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const normalizeUaeEmirate = (value) => {
  const normalizedToken = normalizeEmirateToken(value);

  if (!normalizedToken) {
    return null;
  }

  return EMIRATE_ALIASES[normalizedToken] || null;
};

export const calculateDeliveryCharge = ({ subtotal, emirate }) => {
  const safeSubtotal = Number(subtotal || 0);

  if (safeSubtotal >= FREE_DELIVERY_MINIMUM) {
    return 0;
  }

  const normalizedEmirate = normalizeUaeEmirate(emirate);
  if (!normalizedEmirate) {
    return null;
  }

  return UAE_DELIVERY_CHARGES[normalizedEmirate] ?? null;
};

export const getAmountNeededForFreeDelivery = (subtotal) =>
  Math.max(0, Number((FREE_DELIVERY_MINIMUM - Number(subtotal || 0)).toFixed(2)));
